import holidayService from '../../../common/service/holidayService';
import { updatePdtRequestId } from '../../../../analytics/analytics-utils';

const LISTING_METADATA_URL = '/listing/packages/metadata/v2';

export const getListingMetaData = async params => {
  updatePdtRequestId();
  const response = await holidayService.post(LISTING_METADATA_URL, params);

  return response;
};
